import { gql } from '../../__generated__/gql'

export const ARTISTS_LIST_QUERY = gql(`
  query artistsList($orderBy: SortSongsEnum) {
    artists(orderBy: $orderBy) {
      id
      name
      songsCount
      albumsCount
      picture {
        medium
      }
      albums {
        id
      }
    }
  }
`)
